// Imports for external libraries go here.
import { FC } from 'react';

// Imports for internal (to the monorepo) libraries go here,
import { ErrorDetailProps } from './Error.types';
import { StyledErrorModal } from './Error.styles';
import { mailConst } from '../../util/constants';
import { Heading, Text, Types } from '@marriott/mi-ui-library';

export const ErrorDetail: FC<ErrorDetailProps> = (props: ErrorDetailProps) => {
  const { OUTLET_ADDITIONAL_SECTION, OUTLET_EMAIL_CONTACT, EXTERNAL_LINK } = mailConst;
  return (
    <StyledErrorModal className="brand-css" data-testid="error-modal" data-component-name="o-account-errorModal">
      <div className="error-section">
        <div className="container">
          <div className="row">
            <div className="col-12 pr-0 px-0">
              <div className=" container col-12 col-xl-10">
                {props?.errorData?.status === '500' || props?.errorData?.name === 'AxiosError' ? (
                  <div className="d-flex flex-column inner-container">
                    <Heading
                      variation={Types.headingType.title}
                      fontSize={Types.size.large}
                      element={Types.tags.h4}
                      titleText="A brief pause as we elevate your digital experience."
                      customClass="t-title-m"
                    />

                    <Text
                      element={Types.tags.paragraph}
                      fontSize={Types.size.medium}
                      copyText=" Your refined journey is our priority - Access will be restored as soon as possible. Thank you for your understanding."
                      customClass="error-msg"
                    ></Text>
                  </div>
                ) : (
                  <div className="d-flex flex-column inner-container">
                    <h1>Error</h1>
                    <h5>{props.errorVal}</h5>
                    <p className="mb-0">Please contact our hotel team directly at</p>
                    <p className="mb-0">
                      {props.hotelEmail} or call our property <span>directly for further assistance.</span>
                    </p>
                    {props.hotelPhoneNumber && (
                      <div className="mt-1">
                        <div className={`mt-1 text-left icon-wrapper`}>
                          <a
                            href={`tel:${props.hotelPhoneNumber}`}
                            aria-label="PhoneNumber"
                            className="custom_click_track"
                            data-custom_click_track_value={`Header|'Phone Number'|'Internal'`}
                          >
                            <span className="icon-phone">{props.hotelPhoneNumber}</span>
                          </a>

                          <a
                            href={`mailto:${props.hotelEmail}?subject=Pre-arrival Survey Error - Reservation ${props.confirmationNumber}&body=`}
                            aria-label="Email"
                            className="custom_click_track"
                            custom_click_track_value={`${OUTLET_ADDITIONAL_SECTION}|${OUTLET_EMAIL_CONTACT}|${EXTERNAL_LINK}`}
                          >
                            <span className="icon-mail">{props.hotelEmail}</span>
                          </a>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </StyledErrorModal>
  );
};
